import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios, { AxiosResponse, HttpStatusCode } from "axios";
import { ApiUrlUtil } from "app/utils/apiUrlUtil";
import { HeadersUtil } from "app/utils/headersUtil";
import { ResponseApi, ResponseResultCode } from "app/model/response-api";
import { WeatherModel } from "app/model/common/weatherModel";

interface StateModel {
  today: WeatherModel[],
  tomorrow: WeatherModel[],
}

const initialState: StateModel = {
  today: [],
  tomorrow: [],
};

export const getWeather = createAsyncThunk("weather/weathers", async () => {
  const url = process.env.REACT_APP_URL_CO + '/weather';
  const axiosResponse: AxiosResponse = await axios.get(ApiUrlUtil.buildQueryString(url), {
    headers: HeadersUtil.getHeadersAuth(),
  });

  if (axiosResponse && HttpStatusCode.Ok === axiosResponse.status) {
    const apiResponse: ResponseApi<StateModel> = axiosResponse.data;
    if (apiResponse && ResponseResultCode.Y === apiResponse.resultCode) {
      return apiResponse.data;
    }
  }
  return { today: [], tomorrow: [] };
});

const weatherSlice = createSlice({
  name: 'weather',
  initialState,
  reducers: {
    setWeather: (state, action) => {
      state.today = action.payload.today;
      state.tomorrow = action.payload.tomorrow;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getWeather.pending, () => {})
      .addCase(getWeather.fulfilled, (state, action) => {
        const data: StateModel = action.payload as StateModel;
        if (data) {
          state.today = data.today;
          state.tomorrow = data.tomorrow;
        }
      })
      .addCase(getWeather.rejected, (state) => {
        state.today = [];
        state.tomorrow = [];
      });
  },
});

export default weatherSlice.reducer;